<template>
    <div class="row">
        <div class="col-12 mb-1">
            <label class="form-label">Ödendiği Tarih</label>
            <v-date-picker :disabled="value.Paid != true && editing" v-model="value.PaidDate" placeholder="Ödendiği Tarih"></v-date-picker>
        </div>
        <div class="col-12 mb-1">
            <label class="form-label">Ödeme Dönemi</label>
            <select class="form-control" v-model="value.Period">
                <option v-for="sp in salaryPeriods" :key="sp" :value="sp">{{sp}}</option>
            </select>
        </div>
        <div class="col-12 mb-1">
            <label class="form-label">Tutar (TL)</label>
            <v-currency-input  input-class="text-right" :value="value.PaidAmount" v-on:update-value="currencyAmount => value.PaidAmount = currencyAmount"></v-currency-input>
        </div>
        <div class="col-12">
            <label class="form-label">Açıklama</label>
            <textarea class="form-control resize-none" rows="3" placeholder="Açıklama" v-model="value.Description"></textarea>
        </div>
    </div>
</template>

<script>
import VCurrencyInput from '@/components/VCurrencyInput.vue';
import moment from 'moment'

export default {
    components:{
        VCurrencyInput,
    },
    props:{
        value:Object,
        editing:Boolean
    },
    computed:{
        salaryPeriods(){
            let startYear = moment().year() - 5
            let periods = []
            for(let y = startYear;y<=moment().year();y++){
                for(let i=1;i<=12;i++){
                    periods.push(`${String(i).padStart(2,0)}/${y}`)
                }
            }
            return periods.reverse()
        },
    }
}
</script>